import { useContext, useEffect } from 'react';

import { StockBuySellContext } from '@context/stock/buysell';

const useInitBuySellForm = (code) => {
  const { formAction, dispatch, setActiveCode } = useContext(StockBuySellContext);

  // Setup form on first render
  useEffect(() => {
    if (!code) return;

    dispatch({ type: formAction.SETUP_FORM_CREATE, code });
    setActiveCode(code);
  }, [code]);

  // Cleanup form on unmount
  useEffect(() => {
    return () => {
      if (!code) return;

      dispatch({ type: formAction.RESET_STOCK_FORM, code });
    };
  }, [code]);

  return {};
};

export default useInitBuySellForm;
